// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   Container, Row, Col, Card, CardBody, Button, Form, FormGroup, Input, Label,
//   Breadcrumb, BreadcrumbItem
// } from 'reactstrap';
// import { ArrowLeft, Save, Eye } from 'react-feather';
// import axios from 'axios';
// import Swal from 'sweetalert2';
// import { baseURL } from '../../../../Services/api/baseURL';
// import { H3 } from '../../../../AbstractElements';
// import Loader from '../../../Loader/Loader';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

// const BlogEdit = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const token = JSON.parse(localStorage.getItem("token"));

//   const [formData, setFormData] = useState({
//     title: '',
//     content: '',
//     excerpt: '',
//     tags: '',
//     category: '',
//     readTime: '',
//     metaTitle: '',
//     metaDescription: '',
//     images: [],
//     imagePreview: null,
//     publishDate: new Date().toISOString().slice(0, 16),
//     status: 'draft'
//   });
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);

//   // Rich text editor modules
//   const modules = {
//     toolbar: [
//       [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
//       [{ 'font': [] }],
//       [{ 'size': ['small', false, 'large', 'huge'] }],
//       ['bold', 'italic', 'underline', 'strike'],
//       [{ 'color': [] }, { 'background': [] }],
//       [{ 'script': 'sub' }, { 'script': 'super' }],
//       [{ 'list': 'ordered' }, { 'list': 'bullet' }],
//       [{ 'indent': '-1' }, { 'indent': '+1' }],
//       [{ 'direction': 'rtl' }],
//       [{ 'align': [] }],
//       ['blockquote', 'code-block'],
//       ['link', 'image', 'video'],
//       ['clean']
//     ],
//   };

//   const formats = [
//     'header', 'font', 'size',
//     'bold', 'italic', 'underline', 'strike',
//     'color', 'background',
//     'script',
//     'list', 'bullet',
//     'indent',
//     'direction', 'align',
//     'blockquote', 'code-block',
//     'link', 'image', 'video'
//   ];

//   useEffect(() => {
//     fetchBlogData();
//     fetchCategories();
//   }, [id]);

//   const fetchBlogData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${baseURL}/api/blogs/${id}`, {
//         headers: {
//           Authorization: `${token}`,
//         }
//       });

//       const blogData = response.data.success ? response.data.data : response.data;

//       setFormData({
//         title: blogData.title || '',
//         content: blogData.content || blogData.description || '',
//         excerpt: blogData.excerpt || '',
//         tags: blogData.tags?.join(', ') || '',
//         category: blogData.category || '',
//         readTime: blogData.readTime || '',
//         metaTitle: blogData.metaTitle || blogData.title || '',
//         metaDescription: blogData.metaDescription || '',
//         images: blogData.images || [],
//         imagePreview: blogData.images?.[0] || null,
//         publishDate: blogData.publishDate ? new Date(blogData.publishDate).toISOString().slice(0, 16) : new Date().toISOString().slice(0, 16),
//         status: blogData.status || 'draft'
//       });
//     } catch (error) {
//       console.error('Error fetching blog:', error);
//       Swal.fire({
//         title: "Error",
//         text: "Failed to load blog details",
//         icon: "error",
//         confirmButtonColor: "#fc2c54",
//       });
//       navigate('/blog');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchCategories = async () => {
//     try {
//       const response = await axios.get(`${baseURL}/api/categories`, {
//         headers: {
//           Authorization: `${token}`,
//         }
//       });
//       setCategories(response.data.categories || []);
//     } catch (error) {
//       console.error('Error fetching categories:', error);
//       setCategories([
//         { _id: '1', name: 'Technology' },
//         { _id: '2', name: 'Business' },
//         { _id: '3', name: 'Lifestyle' },
//         { _id: '4', name: 'Health' },
//         { _id: '5', name: 'Travel' }
//       ]);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value, files } = e.target;

//     if (name === 'images' && files.length > 0) {
//       const file = files[0];
//       setFormData(prev => ({
//         ...prev,
//         images: [file],
//         imagePreview: URL.createObjectURL(file)
//       }));
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         [name]: value
//       }));
//     }
//   };

//   const handleContentChange = (content) => {
//     setFormData(prev => ({
//       ...prev,
//       content: content
//     }));

//     // Auto calculate read time (average 200 words per minute)
//     const wordCount = content.replace(/<[^>]*>/g, '').split(/\s+/).length;
//     const readTime = Math.max(1, Math.ceil(wordCount / 200));
//     setFormData(prev => ({
//       ...prev,
//       readTime: `${readTime} min read`
//     }));
//   };

//   const handleSubmit = async (e, statusOverride = null) => {
//     e.preventDefault();
//     setSaving(true);

//     const formPayload = new FormData();
//     formPayload.append('title', formData.title);
//     formPayload.append('content', formData.content);
//     formPayload.append('excerpt', formData.excerpt);
//     formPayload.append('tags', formData.tags);
//     formPayload.append('category', formData.category);
//     formPayload.append('readTime', formData.readTime);
//     formPayload.append('metaTitle', formData.metaTitle);
//     formPayload.append('metaDescription', formData.metaDescription);
//     formPayload.append('publishDate', formData.publishDate);
//     formPayload.append('status', statusOverride || formData.status);

//     if (formData.images[0] instanceof File) {
//       formPayload.append('images', formData.images[0]);
//     }

//     try {
//       const response = await axios.put(`${baseURL}/api/blogs/${id}`, formPayload, {
//         headers: {
//           Authorization: `${token}`,
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       const status = statusOverride || formData.status;

//       Swal.fire({
//         title: status === 'active' ? "Blog Published!" : "Blog Updated!",
//         text: status === 'active' ? "Your blog has been published successfully" : "Your blog has been updated successfully",
//         icon: "success",
//         confirmButtonColor: "#fc2c54",
//         showCancelButton: true,
//         confirmButtonText: "View Blog",
//         cancelButtonText: "Back to List"
//       }).then((result) => {
//         if (result.isConfirmed) {
//           navigate(`/blog-detail/${id}`);
//         } else {
//           navigate('/blog');
//         }
//       });
//     } catch (error) {
//       console.error('Error updating blog:', error);
//       Swal.fire({
//         title: "Error",
//         text: error.response?.data?.message || "Failed to update blog",
//         icon: "error",
//         confirmButtonColor: "#fc2c54",
//       });
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleSaveAsDraft = (e) => {
//     handleSubmit(e, 'draft');
//   };

//   const handlePublishNow = (e) => {
//     handleSubmit(e, 'active');
//   };

//   const handlePreview = () => {
//     if (!formData.title || !formData.content) {
//       Swal.fire({
//         title: "Preview Not Available",
//         text: "Please add a title and content to preview the blog",
//         icon: "warning",
//         confirmButtonColor: "#fc2c54",
//       });
//       return;
//     }
//     navigate(`/blog-detail/${id}`);
//   };

//   const handleBackToBlog = () => {
//     navigate('/blog');
//   };

//   if (loading) {
//     return (
//       <Container fluid style={{ paddingTop: '30px', minHeight: '60vh' }}>
//         <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
//           <Loader />
//         </div>
//       </Container>
//     );
//   }

//   return (
//     <Container fluid style={{ paddingTop: '30px' }}>
//       {/* Breadcrumb */}
//       <Row className="mb-4">
//         <Col xs={12}>
//           <Breadcrumb>
//             <BreadcrumbItem>
//               <Button
//                 color="link"
//                 className="p-0 text-decoration-none"
//                 onClick={handleBackToBlog}
//               >
//                 Blog Management
//               </Button>
//             </BreadcrumbItem>
//             <BreadcrumbItem>
//               <Button
//                 color="link"
//                 className="p-0 text-decoration-none"
//                 onClick={() => navigate(`/blog-detail/${id}`)}
//               >
//                 {formData.title.length > 30 ? formData.title.substring(0, 30) + '...' : formData.title}
//               </Button>
//             </BreadcrumbItem>
//             <BreadcrumbItem active>Edit</BreadcrumbItem>
//           </Breadcrumb>
//         </Col>
//       </Row>

//       {/* Header */}
//       <Row className="mb-4">
//         <Col xs={12} className="d-flex justify-content-between align-items-center">
//           <div>
//             <H3>Edit Blog Post</H3>
//             <p className="text-muted mb-0">Update your blog content and settings</p>
//           </div>
//           <div className="d-flex gap-2">
//             <Button className='cancel_Btn' onClick={handleBackToBlog} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//               <ArrowLeft size={16} className="me-2" />
//               Back to List
//             </Button>
//             <Button color="secondary" onClick={handlePreview} disabled={saving} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
//               <Eye size={16} className="me-2" />
//               Preview
//             </Button>
//           </div>
//         </Col>
//       </Row>

//       <Form onSubmit={handleSubmit}>
//         <Row>
//           {/* Main Content Area */}
//           <Col lg={8}>
//             <Card className="shadow-sm mb-4">
//               <CardBody className="p-4">
//                 <FormGroup>
//                   <Label className="font-medium text-base fw-bold">
//                     Blog Title <span className="text-danger">*</span>
//                   </Label>
//                   <Input
//                     type="text"
//                     name="title"
//                     value={formData.title}
//                     onChange={handleInputChange}
//                     required
//                     placeholder="Enter an engaging blog title..."
//                     style={{ fontSize: '18px', padding: '15px' }}
//                   />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label className="font-medium text-base fw-bold">
//                     Content <span className="text-danger">*</span>
//                   </Label>
//                   <ReactQuill
//                     theme="snow"
//                     value={formData.content}
//                     onChange={handleContentChange}
//                     modules={modules}
//                     formats={formats}
//                     placeholder="Write your blog content here..."
//                     style={{ height: '400px', marginBottom: '50px' }}
//                   />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label className="font-medium text-base fw-bold mt-10">
//                     Excerpt <span className="text-danger">*</span>
//                   </Label>
//                   <Input
//                     type="textarea"
//                     name="excerpt"
//                     value={formData.excerpt}
//                     onChange={handleInputChange}
//                     required
//                     rows="4"
//                     placeholder="Brief description of your blog post (140-160 characters recommended for SEO)"
//                     maxLength="300"
//                   />
//                   <small className="text-muted">{formData.excerpt.length}/300 characters</small>
//                 </FormGroup>
//               </CardBody>
//             </Card>

//             {/* SEO Section */}
//             <Card className="shadow-sm">
//               <CardBody className="p-4">
//                 <h5 className="border-bottom pb-3 mb-4">SEO Settings</h5>
//                 <Row>
//                   <Col lg={6}>
//                     <FormGroup>
//                       <Label className="font-medium text-base fw-bold">Meta Title</Label>
//                       <Input
//                         type="text"
//                         name="metaTitle"
//                         value={formData.metaTitle}
//                         onChange={handleInputChange}
//                         placeholder="SEO optimized title"
//                         maxLength="60"
//                       />
//                       <small className="text-muted">{formData.metaTitle.length}/60 characters</small>
//                     </FormGroup>
//                   </Col>
//                   <Col lg={6}>
//                     <FormGroup>
//                       <Label className="font-medium text-base fw-bold">Meta Description</Label>
//                       <Input
//                         type="textarea"
//                         name="metaDescription"
//                         value={formData.metaDescription}
//                         onChange={handleInputChange}
//                         placeholder="Brief description for search engines"
//                         rows="3"
//                         maxLength="160"
//                       />
//                       <small className="text-muted">{formData.metaDescription.length}/160 characters</small>
//                     </FormGroup>
//                   </Col>
//                 </Row>
//               </CardBody>
//             </Card>
//           </Col>

//           {/* Sidebar */}
//           <Col lg={4}>
//             {/* Publish Settings */}
//             <Card className="shadow-sm mb-4">
//               <CardBody className="p-4">
//                 <h5 className="mb-3">Publish Settings</h5>

//                 <FormGroup>
//                   <Label className="font-medium text-base fw-bold">Status</Label>
//                   <Input
//                     type="select"
//                     name="status"
//                     value={formData.status}
//                     onChange={handleInputChange}
//                   >
//                     <option value="draft">Save as Draft</option>
//                     <option value="active">Publish Now</option>
//                     <option value="inactive">Unpublished</option>
//                   </Input>
//                 </FormGroup>

//                 <FormGroup>
//                   <Label className="font-medium text-base fw-bold">Publish Date</Label>
//                   <Input
//                     type="datetime-local"
//                     name="publishDate"
//                     value={formData.publishDate}
//                     onChange={handleInputChange}
//                   />
//                 </FormGroup>

//                 <FormGroup>
//                   <Label className="font-medium text-base fw-bold">Read Time</Label>
//                   <Input
//                     type="text"
//                     name="readTime"
//                     value={formData.readTime}
//                     readOnly
//                     placeholder="Auto-calculated"
//                     style={{ backgroundColor: '#f8f9fa' }}
//                   />
//                   <small className="text-muted">Automatically calculated based on content length</small>
//                 </FormGroup>

//                 <div className="d-grid gap-2 mt-4">
//                   <Button
//                     color="secondary"
//                     onClick={handlePublishNow}
//                     disabled={saving}
//                     style={{fontWeight: '500' , display: 'flex', alignItems: 'center', gap: '6px' }}
//                     className='d-flex justify-content-center'
//                   >
//                     {saving ? 'Publishing...' : 'Publish Now'}
//                   </Button>
//                   <Button
//                     color="primary"
//                     className='d-flex justify-content-center'
//                     onClick={handleSaveAsDraft}
//                     disabled={saving}
//                     style={{fontWeight: '500' , display: 'flex', alignItems: 'center', gap: '6px' }}
//                   >
//                     <Save size={16} className="me-2" />
//                     {saving ? 'Saving...' : 'Update Blog'}
//                   </Button>
//                 </div>
//               </CardBody>
//             </Card>

//             {/* Featured Image */}
//             <Card className="shadow-sm mb-4">
//               <CardBody className="p-4">
//                 <h5 className="mb-3">Featured Image</h5>
//                 <FormGroup>
//                   <Label className="font-medium text-base fw-bold">
//                     Update Image
//                   </Label>
//                   <Input
//                     type="file"
//                     name="images"
//                     onChange={handleInputChange}
//                     accept="image/*"
//                   />
//                   {formData.imagePreview && (
//                     <div className="mt-3">
//                       <img
//                         src={formData.imagePreview}
//                         alt="Blog Preview"
//                         style={{
//                           width: '100%',
//                           maxHeight: '200px',
//                           objectFit: 'cover',
//                           borderRadius: '8px',
//                           border: '1px solid #e9ecef'
//                         }}
//                       />
//                     </div>
//                   )}
//                 </FormGroup>
//               </CardBody>
//             </Card>

//             {/* Categories and Tags */}
//             {/* <Card className="shadow-sm">
//               <CardBody className="p-4">
//                 <h5 className="mb-3">Organization</h5>
                
//                 <FormGroup>
//                   <Label className="font-medium text-base fw-bold">Category</Label>
//                   <Input
//                     type="select"
//                     name="category"
//                     value={formData.category}
//                     onChange={handleInputChange}
//                   >
//                     <option value="">Select Category</option>
//                     {categories.map(cat => (
//                       <option key={cat._id} value={cat.name}>{cat.name}</option>
//                     ))}
//                   </Input>
//                 </FormGroup>

//                 <FormGroup>
//                   <Label className="font-medium text-base fw-bold">Tags</Label>
//                   <Input
//                     type="text"
//                     name="tags"
//                     value={formData.tags}
//                     onChange={handleInputChange}
//                     placeholder="Enter tags separated by commas"
//                   />
//                   <small className="text-muted">e.g. technology, web development, react</small>
//                 </FormGroup>
//               </CardBody>
//             </Card> */}
//           </Col>
//         </Row>
//       </Form>
//     </Container>
//   );
// };

// export default BlogEdit;

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Row, Col, Card, CardBody, Button, Form, FormGroup, Input, Label,
  Breadcrumb, BreadcrumbItem, Modal, ModalHeader, ModalBody, ModalFooter,
  InputGroup, InputGroupText
} from 'reactstrap';
import { ArrowLeft, Save, Eye, Link, Plus, MessageSquare, Code } from 'react-feather';
import axios from 'axios';
import Swal from 'sweetalert2';
import { baseURL } from '../../../../Services/api/baseURL';
import { H3 } from '../../../../AbstractElements';
import Loader from '../../../Loader/Loader';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const BlogEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("token"));

  const [formData, setFormData] = useState({
    title: '',
    content: '',
    excerpt: '',
    tags: '',
    category: '',
    readTime: '',
    metaTitle: '',
    metaDescription: '',
    images: [],
    imagePreview: null,
    imageAltText: '',
    slug: '',
    originalSlug: '',
    isCustomSlug: false,
    publishDate: new Date().toISOString().slice(0, 16),
    status: 'draft',
    commentsEnabled: true,
    commentsRequireApproval: true
  });
  
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [newCategory, setNewCategory] = useState({ name: '', description: '' });
  const [showHtmlModal, setShowHtmlModal] = useState(false);
  const [htmlContent, setHtmlContent] = useState('');

  // Rich text editor modules
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      [{ 'align': [] }],
      ['blockquote', 'code-block'],
      ['link', 'image', 'video'],
      ['clean']
    ],
  };

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'script',
    'list', 'bullet',
    'indent',
    'direction', 'align',
    'blockquote', 'code-block',
    'link', 'image', 'video'
  ];

  useEffect(() => {
    fetchBlogData();
    fetchCategories();
  }, [id]);

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .trim()
      .replace(/^-+|-+$/g, '');
  };

  const fetchBlogData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseURL}/api/blogs/${id}`, {
        headers: {
          Authorization: `${token}`,
        }
      });

      const blogData = response.data.success ? response.data.data : response.data;
      
      // Get first image alt text
      let imageAltText = '';
      let imageUrl = null;
      if (blogData.images && blogData.images.length > 0) {
        const firstImage = blogData.images[0];
        if (typeof firstImage === 'object') {
          imageAltText = firstImage.altText || '';
          imageUrl = firstImage.url;
        } else {
          imageUrl = firstImage;
        }
      }

      setFormData({
        title: blogData.title || '',
        content: blogData.content || blogData.description || '',
        excerpt: blogData.excerpt || '',
        tags: blogData.tags?.join(', ') || '',
        category: blogData.category?._id || blogData.category || '',
        readTime: blogData.readTime || '',
        metaTitle: blogData.metaTitle || blogData.title || '',
        metaDescription: blogData.metaDescription || '',
        images: blogData.images || [],
        imagePreview: imageUrl,
        imageAltText: imageAltText,
        slug: blogData.slug || '',
        originalSlug: blogData.slug || '',
        isCustomSlug: blogData.isCustomSlug || false,
        publishDate: blogData.publishDate 
          ? new Date(blogData.publishDate).toISOString().slice(0, 16) 
          : new Date().toISOString().slice(0, 16),
        status: blogData.status || 'draft',
        commentsEnabled: blogData.commentsEnabled !== false,
        commentsRequireApproval: blogData.commentsRequireApproval !== false
      });
    } catch (error) {
      console.error('Error fetching blog:', error);
      Swal.fire({
        title: "Error",
        text: "Failed to load blog details",
        icon: "error",
        confirmButtonColor: "#fc2c54",
      });
      navigate('/blog');
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/categories`, {
        headers: {
          Authorization: `${token}`,
        }
      });
      setCategories(response.data.categories || []);
    } catch (error) {
      console.error('Error fetching categories:', error);
      setCategories([]);
    }
  };
const handleSlugBlur = () => {
  if (formData.slug) {
    const formattedSlug = formData.slug
      .replace(/-+/g, '-')        // Now collapse multiple hyphens
      .replace(/^-+|-+$/g, '');   // Remove leading/trailing hyphens
    
    setFormData(prev => ({
      ...prev,
      slug: formattedSlug
    }));
  }
};
  const handleInputChange = (e) => {
    const { name, value, files, type, checked } = e.target;

    if (name === 'images' && files.length > 0) {
      const file = files[0];
      setFormData(prev => ({
        ...prev,
        images: [file],
        imagePreview: URL.createObjectURL(file)
      }));
    } else if (type === 'checkbox') {
      setFormData(prev => ({
        ...prev,
        [name]: checked
      }));
    } else if (name === 'slug') {
  // Allow hyphens while typing - don't over-process
  const formattedSlug = value
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')  // Remove special chars BUT keep hyphens
    .replace(/\s+/g, '-');          // Replace spaces with hyphens
  
  setFormData(prev => ({
    ...prev,
    slug: formattedSlug,
    isCustomSlug: true
  }));
} else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleContentChange = (content) => {
    setFormData(prev => ({
      ...prev,
      content: content
    }));

    // Auto calculate read time
    const wordCount = content.replace(/<[^>]*>/g, '').split(/\s+/).length;
    const readTime = Math.max(1, Math.ceil(wordCount / 200));
    setFormData(prev => ({
      ...prev,
      readTime: `${readTime} min read`
    }));
  };

  const openHtmlEditor = () => {
    setHtmlContent(formData.content);
    setShowHtmlModal(true);
  };

  const saveHtmlContent = () => {
    setFormData(prev => ({
      ...prev,
      content: htmlContent
    }));
    setShowHtmlModal(false);
  };

  const handleCreateCategory = async () => {
    if (!newCategory.name.trim()) {
      Swal.fire({
        title: "Error",
        text: "Category name is required",
        icon: "error",
        confirmButtonColor: "#fc2c54",
      });
      return;
    }

    try {
      const response = await axios.post(`${baseURL}/api/categories`, newCategory, {
        headers: {
          Authorization: `${token}`,
        }
      });

      const createdCategory = response.data.data;
      setCategories(prev => [...prev, createdCategory]);
      setFormData(prev => ({
        ...prev,
        category: createdCategory._id
      }));
      setShowCategoryModal(false);
      setNewCategory({ name: '', description: '' });

      Swal.fire({
        title: "Success!",
        text: "Category created successfully",
        icon: "success",
        timer: 2000,
        showConfirmButton: false
      });
    } catch (error) {
      console.error('Error creating category:', error);
      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "Failed to create category",
        icon: "error",
        confirmButtonColor: "#fc2c54",
      });
    }
  };

  const handleSubmit = async (e, statusOverride = null) => {
    e.preventDefault();
    setSaving(true);

    const formPayload = new FormData();
    formPayload.append('title', formData.title);
    formPayload.append('content', formData.content);
    formPayload.append('excerpt', formData.excerpt);
    formPayload.append('tags', formData.tags);
    formPayload.append('category', formData.category);
    formPayload.append('readTime', formData.readTime);
    formPayload.append('metaTitle', formData.metaTitle);
    formPayload.append('metaDescription', formData.metaDescription);
    formPayload.append('publishDate', formData.publishDate);
    formPayload.append('status', statusOverride || formData.status);
    
    // New fields
    if (formData.slug !== formData.originalSlug) {
      formPayload.append('slug', formData.slug);
    }
    formPayload.append('imageAltText', formData.imageAltText);
    formPayload.append('commentsEnabled', formData.commentsEnabled);
    formPayload.append('commentsRequireApproval', formData.commentsRequireApproval);

    if (formData.images[0] instanceof File) {
      formPayload.append('images', formData.images[0]);
    }

    try {
      const response = await axios.put(`${baseURL}/api/blogs/${id}`, formPayload, {
        headers: {
          Authorization: `${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      const status = statusOverride || formData.status;

      Swal.fire({
        title: status === 'active' ? "Blog Published!" : "Blog Updated!",
        text: status === 'active' ? "Your blog has been published successfully" : "Your blog has been updated successfully",
        icon: "success",
        confirmButtonColor: "#fc2c54",
        showCancelButton: true,
        confirmButtonText: "View Blog",
        cancelButtonText: "Back to List"
      }).then((result) => {
        if (result.isConfirmed) {
          navigate(`/blog-detail/${id}`);
        } else {
          navigate('/blog');
        }
      });
    } catch (error) {
      console.error('Error updating blog:', error);
      Swal.fire({
        title: "Error",
        text: error.response?.data?.message || "Failed to update blog",
        icon: "error",
        confirmButtonColor: "#fc2c54",
      });
    } finally {
      setSaving(false);
    }
  };

  const handleSaveAsDraft = (e) => {
    handleSubmit(e, 'draft');
  };

  const handlePublishNow = (e) => {
    handleSubmit(e, 'active');
  };

  const handlePreview = () => {
    if (!formData.title || !formData.content) {
      Swal.fire({
        title: "Preview Not Available",
        text: "Please add a title and content to preview the blog",
        icon: "warning",
        confirmButtonColor: "#fc2c54",
      });
      return;
    }
    navigate(`/blog-detail/${id}`);
  };

  const handleBackToBlog = () => {
    navigate('/blog');
  };

  if (loading) {
    return (
      <Container fluid style={{ paddingTop: '30px', minHeight: '60vh' }}>
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <Loader />
        </div>
      </Container>
    );
  }

  return (
    <Container fluid style={{ paddingTop: '30px' }}>
      {/* Breadcrumb */}
      <Row className="mb-4">
        <Col xs={12}>
          <Breadcrumb>
            <BreadcrumbItem>
              <Button
                color="link"
                className="p-0 text-decoration-none"
                onClick={handleBackToBlog}
              >
                Blog Management
              </Button>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Button
                color="link"
                className="p-0 text-decoration-none"
                onClick={() => navigate(`/blog-detail/${id}`)}
              >
                {formData.title.length > 30 ? formData.title.substring(0, 30) + '...' : formData.title}
              </Button>
            </BreadcrumbItem>
            <BreadcrumbItem active>Edit</BreadcrumbItem>
          </Breadcrumb>
        </Col>
      </Row>

      {/* Header */}
      <Row className="mb-4">
        <Col xs={12} className="d-flex justify-content-between align-items-center">
          <div>
            <H3>Edit Blog Post</H3>
            <p className="text-muted mb-0">Update your blog content and settings</p>
          </div>
          <div className="d-flex gap-2">
            <Button className='cancel_Btn' onClick={handleBackToBlog} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <ArrowLeft size={16} className="me-2" />
              Back to List
            </Button>
            <Button color="secondary" onClick={handlePreview} disabled={saving} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Eye size={16} className="me-2" />
              Preview
            </Button>
          </div>
        </Col>
      </Row>

      <Form onSubmit={handleSubmit}>
        <Row>
          {/* Main Content Area */}
          <Col lg={8}>
            <Card className="shadow-sm mb-4">
              <CardBody className="p-4">
                <FormGroup>
                  <Label className="font-medium text-base fw-bold">
                    Blog Title <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter an engaging blog title..."
                    style={{ fontSize: '18px', padding: '15px' }}
                  />
                </FormGroup>

                {/* URL Slug Field */}
                <FormGroup>
                  <Label className="font-medium text-base fw-bold">
                    <Link size={14} className="me-2" />
                    URL Slug
                  </Label>
                  <InputGroup>
                    <InputGroupText style={{ fontSize: '12px', backgroundColor: '#f8f9fa' }}>
                      /blogs/
                    </InputGroupText>
                    <Input
                      type="text"
                      name="slug"
                      value={formData.slug}
                      onChange={handleInputChange}
                        onBlur={handleSlugBlur} 
                      placeholder="your-blog-url-here"
                    />
                  </InputGroup>
                  {formData.slug !== formData.originalSlug && (
                    <small className="text-warning">
                      ⚠️ URL will change from <code>/{formData.originalSlug}</code> to <code>/{formData.slug}</code>
                    </small>
                  )}
                </FormGroup>

                <FormGroup>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <Label className="font-medium text-base fw-bold mb-0">
                      Content <span className="text-danger">*</span>
                    </Label>
                    <Button 
                      color="outline-secondary" 
                      size="sm" 
                      onClick={openHtmlEditor}
                      style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                    >
                      <Code size={14} />
                      Edit HTML
                    </Button>
                  </div>
                  <ReactQuill
                    theme="snow"
                    value={formData.content}
                    onChange={handleContentChange}
                    modules={modules}
                    formats={formats}
                    placeholder="Write your blog content here..."
                    style={{ height: '400px', marginBottom: '50px' }}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="font-medium text-base fw-bold mt-10">
                    Excerpt <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="textarea"
                    name="excerpt"
                    value={formData.excerpt}
                    onChange={handleInputChange}
                    required
                    rows="4"
                    placeholder="Brief description of your blog post (140-160 characters recommended for SEO)"
                    maxLength="300"
                  />
                  <small className="text-muted">{formData.excerpt.length}/300 characters</small>
                </FormGroup>
              </CardBody>
            </Card>

            {/* SEO Section */}
            <Card className="shadow-sm">
              <CardBody className="p-4">
                <h5 className="border-bottom pb-3 mb-4">SEO Settings</h5>
                <Row>
                  <Col lg={6}>
                    <FormGroup>
                      <Label className="font-medium text-base fw-bold">Meta Title</Label>
                      <Input
                        type="text"
                        name="metaTitle"
                        value={formData.metaTitle}
                        onChange={handleInputChange}
                        placeholder="SEO optimized title"
                        maxLength="60"
                      />
                      <small className="text-muted">{formData.metaTitle.length}/60 characters</small>
                    </FormGroup>
                  </Col>
                  <Col lg={6}>
                    <FormGroup>
                      <Label className="font-medium text-base fw-bold">Meta Description</Label>
                      <Input
                        type="textarea"
                        name="metaDescription"
                        value={formData.metaDescription}
                        onChange={handleInputChange}
                        placeholder="Brief description for search engines"
                        rows="3"
                        maxLength="160"
                      />
                      <small className="text-muted">{formData.metaDescription.length}/160 characters</small>
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          {/* Sidebar */}
          <Col lg={4}>
            {/* Publish Settings */}
            <Card className="shadow-sm mb-4">
              <CardBody className="p-4">
                <h5 className="mb-3">Publish Settings</h5>

                <FormGroup>
                  <Label className="font-medium text-base fw-bold">Status</Label>
                  <Input
                    type="select"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                  >
                    <option value="draft">Save as Draft</option>
                    <option value="active">Publish Now</option>
                    <option value="inactive">Unpublished</option>
                  </Input>
                </FormGroup>

                <FormGroup>
                  <Label className="font-medium text-base fw-bold">Publish Date</Label>
                  <Input
                    type="datetime-local"
                    name="publishDate"
                    value={formData.publishDate}
                    onChange={handleInputChange}
                  />
                </FormGroup>

                <FormGroup>
                  <Label className="font-medium text-base fw-bold">Read Time</Label>
                  <Input
                    type="text"
                    name="readTime"
                    value={formData.readTime}
                    readOnly
                    placeholder="Auto-calculated"
                    style={{ backgroundColor: '#f8f9fa' }}
                  />
                  <small className="text-muted">Automatically calculated based on content length</small>
                </FormGroup>

                <div className="d-grid gap-2 mt-4">
                  <Button
                    color="secondary"
                    onClick={handlePublishNow}
                    disabled={saving}
                    style={{ fontWeight: '500', display: 'flex', alignItems: 'center', gap: '6px' }}
                    className='d-flex justify-content-center'
                  >
                    {saving ? 'Publishing...' : 'Publish Now'}
                  </Button>
                  <Button
                    color="primary"
                    className='d-flex justify-content-center'
                    onClick={handleSaveAsDraft}
                    disabled={saving}
                    style={{ fontWeight: '500', display: 'flex', alignItems: 'center', gap: '6px' }}
                  >
                    <Save size={16} className="me-2" />
                    {saving ? 'Saving...' : 'Update Blog'}
                  </Button>
                </div>
              </CardBody>
            </Card>

            {/* Featured Image with Alt Text */}
            <Card className="shadow-sm mb-4">
              <CardBody className="p-4">
                <h5 className="mb-3">Featured Image</h5>
                <FormGroup>
                  <Label className="font-medium text-base fw-bold">
                    Update Image
                  </Label>
                  <Input
                    type="file"
                    name="images"
                    onChange={handleInputChange}
                    accept="image/*"
                  />
                  {formData.imagePreview && (
                    <div className="mt-3">
                      <img
                        src={formData.imagePreview}
                        alt={formData.imageAltText || 'Blog Preview'}
                        style={{
                          width: '100%',
                          maxHeight: '200px',
                          objectFit: 'cover',
                          borderRadius: '8px',
                          border: '1px solid #e9ecef'
                        }}
                      />
                    </div>
                  )}
                </FormGroup>
                
                {/* Image Alt Text Field */}
                <FormGroup className="mt-3">
                  <Label className="font-medium text-base fw-bold">
                    Image Alt Text (SEO)
                  </Label>
                  <Input
                    type="text"
                    name="imageAltText"
                    value={formData.imageAltText}
                    onChange={handleInputChange}
                    placeholder="Describe the image for accessibility & SEO"
                    maxLength="200"
                  />
                  <small className="text-muted">
                    Describe what's in the image. Important for SEO and accessibility.
                  </small>
                </FormGroup>
              </CardBody>
            </Card>

            {/* Categories */}
            <Card className="shadow-sm mb-4">
              <CardBody className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Category</h5>
                  <Button 
                    color="link" 
                    size="sm" 
                    onClick={() => setShowCategoryModal(true)}
                    style={{ padding: 0 }}
                  >
                    <Plus size={16} className="me-1" />
                    New
                  </Button>
                </div>
                
                <FormGroup>
                  <Input
                    type="select"
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Category</option>
                    {categories.map(cat => (
                      <option key={cat._id} value={cat._id}>{cat.name}</option>
                    ))}
                  </Input>
                </FormGroup>

                <FormGroup>
                  <Label className="font-medium text-base fw-bold">Tags</Label>
                  <Input
                    type="text"
                    name="tags"
                    value={formData.tags}
                    onChange={handleInputChange}
                    placeholder="Enter tags separated by commas"
                  />
                  <small className="text-muted">e.g. technology, web development, react</small>
                </FormGroup>
              </CardBody>
            </Card>

            {/* Comment Settings */}
            <Card className="shadow-sm">
              <CardBody className="p-4">
                <h5 className="mb-3">
                  <MessageSquare size={18} className="me-2" />
                  Comment Settings
                </h5>
                
                <FormGroup check className="mb-3">
                  <Input
                    type="checkbox"
                    name="commentsEnabled"
                    id="commentsEnabled"
                    checked={formData.commentsEnabled}
                    onChange={handleInputChange}
                  />
                  <Label check for="commentsEnabled">
                    Enable comments on this blog
                  </Label>
                </FormGroup>

                <FormGroup check>
                  <Input
                    type="checkbox"
                    name="commentsRequireApproval"
                    id="commentsRequireApproval"
                    checked={formData.commentsRequireApproval}
                    onChange={handleInputChange}
                    disabled={!formData.commentsEnabled}
                  />
                  <Label check for="commentsRequireApproval">
                    Comments require approval before publishing
                  </Label>
                </FormGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Form>

      {/* Create Category Modal */}
      <Modal isOpen={showCategoryModal} toggle={() => setShowCategoryModal(false)}>
        <ModalHeader toggle={() => setShowCategoryModal(false)}>
          Create New Category
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Category Name <span className="text-danger">*</span></Label>
            <Input
              type="text"
              value={newCategory.name}
              onChange={(e) => setNewCategory(prev => ({ ...prev, name: e.target.value }))}
              placeholder="Enter category name"
            />
          </FormGroup>
          <FormGroup>
            <Label>Description</Label>
            <Input
              type="textarea"
              value={newCategory.description}
              onChange={(e) => setNewCategory(prev => ({ ...prev, description: e.target.value }))}
              placeholder="Enter category description (optional)"
              rows="3"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowCategoryModal(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleCreateCategory}>
            Create Category
          </Button>
        </ModalFooter>
      </Modal>

      {/* HTML Editor Modal */}
      <Modal isOpen={showHtmlModal} toggle={() => setShowHtmlModal(false)} size="xl">
        <ModalHeader toggle={() => setShowHtmlModal(false)}>
          <Code size={18} className="me-2" />
          Edit HTML Source
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>HTML Content</Label>
            <Input
              type="textarea"
              value={htmlContent}
              onChange={(e) => setHtmlContent(e.target.value)}
              style={{ 
                fontFamily: 'monospace', 
                fontSize: '13px',
                minHeight: '400px',
                backgroundColor: '#f8f9fa'
              }}
            />
          </FormGroup>
          <small className="text-muted">
            You can add custom HTML tags here. Common tags: &lt;div&gt;, &lt;span&gt;, &lt;table&gt;, &lt;iframe&gt;, etc.
          </small>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowHtmlModal(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={saveHtmlContent}>
            Apply HTML
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default BlogEdit;